import { Spacer } from '../../types';

export type LoadingProps = {
	size?: number;
	strokeWidth?: number;
	color?: string;
	duration?: string;
	marginBottom?: Spacer;
	height?: string;	
};

export const Loading: React.FC<LoadingProps> = ({
	size = 38,
	color = '#f47920',
	strokeWidth = 2,
	duration = '0.9s',
	marginBottom = 3,
	height	
}) => {
	const MOVE = size * (18 / 19);
	const SIZE_2 = size / 2;
	const BEZIER_1 = size * 0.261578947;
	const BEZIER_2 = size * 0.212105263;

	return (
		<div 
			className={`d-flex align-items-center justify-content-center overflow-hidden mb-${marginBottom} loading ${
				height && 'h-auto'
			}`}
		>
			<svg
				width={size}
				height={size}
				viewBox={`0 0 ${size + size * 0.1} ${size + size * 0.1}`}
				xmlns="http://www.w3.org/2000/svg"
			>
				<defs>
					<linearGradient
						x1="8.042%"
						y1="0%"
						x2="65.682%"
						y2="23.865%"
						id="a"
					>
						<stop stopColor={color} stopOpacity="0" offset="0%" />

						<stop
							stopColor={color}
							stopOpacity=".631"
							offset="63.146%"
						/>

						<stop stopColor={color} offset="100%" />
					</linearGradient>
				</defs>

				<g fill="none" fillRule="evenodd">
					<g transform="translate(1 1)">
						<path
							d={`M${MOVE} ${SIZE_2}c0-${BEZIER_1}-${BEZIER_2}-${SIZE_2}-${SIZE_2}-${SIZE_2}`}
							id="Oval-2"
							stroke="url(#a)"
							strokeWidth={strokeWidth}
						>
							<animateTransform
								attributeName="transform"
								type="rotate"
								from={`0 ${SIZE_2} ${SIZE_2}`}
								to={`360 ${SIZE_2} ${SIZE_2}`}
								dur={duration}
								repeatCount="indefinite"
							/>
						</path>

						<circle fill={color} cx={MOVE} cy={SIZE_2} r="1">
							<animateTransform
								attributeName="transform"
								type="rotate"
								from={`0 ${SIZE_2} ${SIZE_2}`}
								to={`360 ${SIZE_2} ${SIZE_2}`}
								dur={duration}
								repeatCount="indefinite"
							/>
						</circle>
					</g>
				</g>
			</svg>
		</div>
	);
};


